/** Contenedor de página: altura según contenido (evita hueco al scroll en layout flex). */
export function demandPlanningPageClass(_embedded = false): string {
  return 'w-full min-w-0 h-fit px-4 md:px-6 pb-4 space-y-5 md:space-y-6';
}
